<template>
    <!---------- FEATURED STORY ---------->

    <section class="featured-story">
        <div class="container">
            <div class="row rounded-5" style="background: #2F437A;" id="story">

                <!--------------------- Left Box ------------------------>

                <div class="col-md-5" id="left-box">
                    <div class="featured-image mb-3">
                        <img class="img-fluid" src="@/assets/testimonials-img/story.png">
                    </div>
                </div>

                <!---------------------- Right Box ----------------------->

                <div class="col-md-7 justify-content-center align-items-center" id="right-box">
                    <h1 id="main-text">BRIGADATECHSKWELA</h1>
                    <h2 id="sub-text">FEATURED STORY</h2>
                    <div class="para1">
                        <p class="p1">Deserve po ng mga anak ko na mapili at mabigyan ng tablet para sa kanilang online
                            class dahil isa po akong single mom at walang suporta at permanenteng trabaho. Mag-isa ko po
                            silang tinataguyod at pinag-aaral sa pamamagitan ng paglalabada pero dahil nga po sa COVID 19 ay
                            bihira na ang nagpapalaba kaya wala po talaga akong kakayahan na maibili sila ng tablet na
                            pangarap nila. Pinagtitiyagan po namin ang malit at malabo na cellphone na gamit ko ngayon at
                            gamit din nila pang-online class.</p>
                        <br>
                        <p class="p1">Madalas din po ay hindi nakakapag-online class ang isa sa kanila pag nagkakasabay ang
                            klase nila kaya hoping po talaga kung mananalo at pangarap po talaga kung mananalo at pangarap
                            po talaga nila na magkaroon ng tablet. Maraming salamat po at sana ay madami pa kayong
                            matulungan. Godless po.</p>
                    </div>
                </div>


            </div>
        </div>

    </section>

    <!---------- TESTIMONIALS ---------->

    <section class="testimonials">


        <div class="container-fluid" id="test">

            <h3 id="test-txt">BENEFICIARIES' TESTIMONIALS</h3>

            <!-- 1st testimony -->
            <div class="row d-flex justify-content-center align-items-center">
                <div class="div1">
                    <img src="@/assets/testimonials-img/bene1.png" class="img-left">
                    <div class="div2">
                        <p class="p2"> Edna Magsico Domingo </p>
                        <p class="p3"> Thank you so much Sir Aldrin, Maam Katarina at sa lahat po ng bumubuo ng TFYO most
                            especially sa sponsors po ng organization.
                            Thank you very much and Godbless us all po.</p>
                    </div>
                </div>
            </div>

            <!-- 2nd Testimony -->
            <div class="row d-flex justify-content-center align-items-center">
                <div class="div1">
                    <img src="@/assets/testimonials-img/bene2.png" class="img-right">
                    <div class="div3">
                        <p class="p2"> Melinda Pabalan </p>
                        <p class="p3">Maraming-maraming salamat po sa bumubuo ng Tech for Filipino Youth Organization at sa
                            mga sponsors malaking tulong po eto sa pag aaral ng mga anak ko.
                            Kay Sir Aldrin at kay Mam Katarina sobrang salamat po and Godbless. </p>
                    </div>

                </div>
            </div>

            <!-- 3rd Testimony -->
            <div class="row d-flex justify-content-center align-items-center">
                <div class="div1">
                    <img src="@/assets/testimonials-img/bene3.png" class="img-left">
                    <div class="div2">
                        <p class="p2"> Mary Ann R. Mendoza </p>
                        <p class="p3"> Maraming-maraming salamat po sa ipinagkaloob nyo pong tablet para po sa anak ko po.
                            Malaking tulong po ito sa kanyang pag-aaral.
                            Iingatan po namin ito para magamit po niya sa high school po. Thank you po ulit sana marami pa
                            po kayong matulungang kabataan. God Bless po!</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!---------- FEATURED SCHOOL ---------->

    <section class="school-bg">
        <div class="container-fluid" id="school-container">
            <div class="texts">
                <h4 id="school-txt">FEATURED SCHOOL</h4>
                <p class="p4">"San Roque Elementary School teachers, parents and learners would like to express our
                    sincerest
                    thanks and gratitude to the assistance extended to our learners. Indeed, your continuous support to our
                    learners is a big help.
                    Rest assured that our school will continue providing accessible and quality education for all through
                    your support.
                    Special thanks to MR. ALDRIN LICAYAN, Founder of TFYO, MR. JOHN FREDMARC CARAGOS, the Events Manager of
                    the said organization and the team for
                    gracing the affair. May God bless you!"</p>
            </div>
            <div class="featured-school">
                <img src="@/assets/testimonials-img/school.png" class="school-img">

            </div>
        </div>
    </section>

    <!------------- GALLERY -------------->

    <section>
        <div class="container-fluid" id="gal-container">
            <h5 class="gal-txt">BENEFICIARIES' GALLERY</h5>
            <div class="rowzie">

                <img src="@/assets/testimonials-img/gallery/ben1.png" />

                <img src="@/assets/testimonials-img/gallery/ben3.png" />

                <img src="@/assets/testimonials-img/gallery/ben2.png" />

                <img src="@/assets/testimonials-img/gallery/ben4.png" />

                <img src="@/assets/testimonials-img/gallery/ben5.png" />

                <img src="@/assets/testimonials-img/gallery/ben6.png" />

                <img src="@/assets/testimonials-img/gallery/ben7.png" />

                <img src="@/assets/testimonials-img/gallery/ben8.png" />

                <img src="@/assets/testimonials-img/gallery/ben9.png" />


            </div>
        </div>
    </section></template>

<style scoped src="@/assets/css/globalStyle.css"></style>
<style scoped src="@/assets/css/testimonials.css"></style>"
